import {
  getSubscriptionById,
  getUserSubscriptions
} from "./chunk-RIPSFUK2.mjs";

// src/hooks/wbk/subscriptions/user.ts
import { useQuery } from "@tanstack/react-query";
var useGetSubscriptionById = (props) => {
  return useQuery({
    queryKey: ["getSubscriptionById", props],
    queryFn: () => getSubscriptionById(props)
  });
};
var useGetUserSubscriptions = (props) => {
  return useQuery({
    queryKey: ["getUserSubscriptions", props],
    queryFn: () => getUserSubscriptions(props)
  });
};

export {
  useGetSubscriptionById,
  useGetUserSubscriptions
};
//# sourceMappingURL=chunk-JALTRAPN.mjs.map